import api from '@/helpers/api.js';

/**
 * Maps commerce search results.
 *
 * @param {Array.<Object>} results - The list of commerce search results.
 *
 * @returns {Array.<Object>}
 */
export default function mapCommerceSearchResults(results = []) {
  if (!Array.isArray(results)) {
    return [];
  }

  return results.map((result) => {
    const image = result.images?.[0];

    return {
      ...result,
      title: result.displayName,
      price: result.price?.formattedValue,
      url: api.getUrl('shop-path', {
        path: result.url,
      }),
      image: image && {
        srcset: image.url,
        alt: image.altText,
        fallback: image.url,
      },
    };
  });
}
